module.exports = __webpack_public_path__ + "img/TaShina Morris.20fce409.jpg";